// Import Packages
import React, { useEffect, useState } from 'react'
import { useSetRecoilState } from 'recoil';
import { useTranslation } from 'react-i18next'


// Import Material UI
import { Close } from '@material-ui/icons'
import { Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, InputAdornment, MenuItem, TextField, Typography } from '@material-ui/core'

// Import Services
import DashBoardService from '../../../../../services/DashBoardService/DashBoardService'

// Import Icons
import VerticalChartIcon from '../../../../../assets/icons/dasboardIcons/vertical-chart-icon.svg';
import HorizontalChartIcon from '../../../../../assets/icons/dasboardIcons/horizontal-chart-icon.svg';
import GroupableVerticalChartIcon from '../../../../../assets/icons/dasboardIcons/vertical-groupable-chart-icon.svg';
import GroupableHorizontalChartIcon from '../../../../../assets/icons/dasboardIcons/horizontal-groupable-chart-icon.svg';
import PieChartIcon from '../../../../../assets/icons/dasboardIcons/pie-chart-icon.svg';
import StringIcon from '../../../../../assets/icons/dasboardIcons/string-icon.svg';

// Import Pages
import Search from '../../../../../components/FlowConfigurationForms/String/Search/Search'
import ReportsAccordion from './ReportsAccordion'

// Import Recoil
import { alertState } from "../../../../../recoil-store/recoil-state";

const CreateWidget = ({ id, order, handleClose, selectedDashboard, label }) => {
    const { t } = useTranslation();
    const [selectedData, setSelectedData] = useState({})
    const [selectedReport, setSelectedReport] = useState({})
    const [widgetWidth, setWidgetWidth] = useState(1)
    const [widgetHeight, setWidgetHeight] = useState(1)
    const [step, setStep] = useState(1)
    const [data, setData] = useState([])
    const [widgets, setWidgets] = useState([])
    const setAlert = useSetRecoilState(alertState);
    const [widgetTitle, setWidgetTitle] = useState("")


    const [completeData, setCompleteData] = useState({
        columns: [],
        groupBy: null,
        customFilters: [{ column: null, operator: null, value: "", mandatory: false }],  // { column: {}, operator: "", value: "", mandatory: false, custom_date: {"start_date":"","end_date":""} }
        sorting: null,
        widgetVisualization: {},
        persist_date_filter: false
    })

    /* 
        view_report_id: selectedData.id
        row 1
        column 1
        table_columns: [""]
        group_by_columns : [""]
        filter_columns: []
        sorting_columns: []
        {"column":"","operator":"","value":"","mandatory":false}
        {"column":"","operator":"custom","custom_date":{"start_date":"","end_date":""},"mandatory":false}
        {"column":"","operator":"weekly","mandatory":false}
    */

    const [columns, setColumns] = useState([
        "COLUMNS", "GROUP-BY", "CUSTOM-FILTERS", "SORTING", "WIDGET-VISUALIZATION"
    ])


    useEffect(() => {
        if (!id) {
            fetchReports()
        }

    }, [])

    const fetchReports = async () => {
        const res = await DashBoardService.getDashBoardReports()
        if (res.status) {
            setData(res.data)
            return res.data
        } else {
            // mesaj yazılacak.
            setData([]);
        }
    }
    useEffect(() => {
        if (step === 2 && !id) {
            fetchWidgets()
        }
    }, [step])

    const fetchWidgets = async () => {
        const res = await DashBoardService.getCharts()
        if (res.status) {
            setWidgets(res.data)
            return res.data
        } else {
            // mesaj yazılacak.
            setWidgets([]);
        }
    }

    useEffect(() => {
        if (id) {
            const fetchData = async () => {
                // güncelleme için gelindiği için 1. aşama atlandı
                setStep(2);
                const w = await DashBoardService.getWidgetById(id);
                if (w.status) {

                    setWidgetTitle(w.data.display_name)
                    setWidgetHeight(w.data.row)
                    setWidgetWidth(w.data.column)

                    const drd = await DashBoardService.getDashBoardReportDetail(w.data.view_report_id)
                    const widgetsData = await fetchWidgets()
                    const reports = await fetchReports();
                    setSelectedReport(drd.data)
                    for (const report of reports) {
                        const sr = report.view_reports.find(x => x.id === w.data.view_report_id);
                        if (sr) {
                            setSelectedData(sr);
                            break;
                        }
                    }

                    const table_columns = drd.data.columns.filter(x => w.data.table_columns.some(tc => tc === x.value));
                    const widgetVisualization = widgetsData.find(x => w.data?.widget_id === x.id);
                    widgetVisualization.img = getWidgetImg(widgetVisualization.name);
                    const group_by_columns = drd.data.group_by_columns.find(x => w.data.group_by_columns.some(gb => gb === x.value));
                    let filter_columns = [{ column: null, operator: null, value: "", mandatory: false }];
                    if (w.data.filter_columns?.length) {
                        filter_columns = w.data.filter_columns;
                    }

                    setCompleteData({
                        columns: table_columns,
                        groupBy: group_by_columns ? group_by_columns : null,
                        customFilters: filter_columns,
                        sorting: w.data.sorting_columns && w.data.sorting_columns.length ? w.data.sorting_columns[0] : null,
                        widgetVisualization: widgetVisualization ? widgetVisualization : [],
                        persist_date_filter: w.data.persist_date_filter ? true : false
                    });


                    /*
                        [
                            'id', 'display_name', 'order',
                            'row', 'column', 'table_columns', 'dashboard_id',
                            'widget_id', 'view_report_id', 'group_by_columns',
                            'filter_columns', 'sorting_columns', 'persist_date_filter'
                        ]
                    */
                }
            }
            fetchData()
        }
    }, [id])

    const getWidgetImg = (widgetName) => {
        switch (widgetName) {
            case "vertical bar":
                return VerticalChartIcon;
            case "string chart":
                return StringIcon;
            case "pie chart":
                return PieChartIcon;
            case "groupable vertical bar":
                return GroupableVerticalChartIcon
            case "groupable horizontal bar":
                return GroupableHorizontalChartIcon
            case "horizontal bar":
                return HorizontalChartIcon;
            default:
                break;
        }
    }

    const returnToDefault = () => {
        setCompleteData({
            groupBy: null,
            columns: [],
            customFilters: [{ column: null, operator: null, value: "", mandatory: false }],
            sorting: null,
            widgetVisualization: [],
            persist_date_filter: false
        })
        // setSelectedData({})
    }

    const fetchReportDetail = async (id) => {
        const res = await DashBoardService.getDashBoardReportDetail(id)
        if (res.status) {
            let disabledColumns = []
            let disabledGroup = {}
            if (res.data?.columns?.length) {
                res.data?.columns.forEach(column => {
                    if (column.disabled) {
                        disabledColumns.push(column)
                    }
                });
            }
            if (res.data?.group_by_columns) {
                disabledGroup = res.data?.group_by_columns.find(column => column.disabled);
            }
            if (disabledColumns?.length) {
                setCompleteData((pre) => {
                    return { ...pre, columns: disabledColumns }
                })
            }
            if (disabledGroup?.label) {
                setCompleteData((pre) => {
                    return { ...pre, groupBy: disabledGroup }
                })
            }
            setSelectedReport(res.data)

        }
    }

    const handleNext = () => {
        if (selectedData.label && selectedData.id) {
            setStep((pre) => pre + 1)
            fetchReportDetail(selectedData.id)
        }
    }

    const handleBack = () => {
        // burada önemli olan raporun değişmesi. Rapor değişirse sıfırlama yapılmalıdır.

        // setCompleteData({
        //     groupBy: null,
        //     columns: [],
        //     customFilters: [{ column: null, operator: null, value: "", mandatory: false }],
        //     sorting: null,
        //     widgetVisualization: [],
        // })
        // setSelectedData({})
        setStep((pre) => pre - 1)
    }

    const handleAddToDashboard = async () => {
        if (!completeData.columns?.length) {
            return setAlert(alert => ({
                ...alert,
                show: true,
                message: t(label + 'YOU-MUST-SELECT-AT-LEAST-ONE-COLUMN'), //You must select at least 1 column
                severity: 'error'
            }))
        }
        if (!completeData.widgetVisualization?.id) {
            return setAlert(alert => ({
                ...alert,
                show: true,
                message: t(label + 'YOU-MUST-SELECT-AT-LEAST-ONE-WIDGET'), //You must select at least 1 column
                severity: 'error'
            }))
        }
        if (!selectedDashboard?.id) {
            return setAlert(alert => ({
                ...alert,
                show: true,
                message: t(label + 'DASHBOARD-ID-NOT-FOUND'), //You must select at least 1 column
                severity: 'error'
            }))
        }

        // eğer customFilters içerisinde 1 tane veri varsa ve kolon seçilmediyse veriyi servise boş gönder.

        let filter_columns = [];
        if (completeData.customFilters?.length > 0 && completeData.customFilters[0].column) {
            let isEmpty = false
            for (let index = 0; index < completeData.customFilters.length; index++) {
                const column = completeData.customFilters[index].column
                const operator = completeData.customFilters[index].operator
                const value = completeData.customFilters[index].value
                const custom_date = completeData.customFilters[index].custom_date
                if (column && column?.type === "string" && column?.value) {
                    if (operator && operator?.value && operator?.value !== 'empty' && operator?.value !== 'nempty' && column?.type !== 'date_time') {
                        if (!value) {
                            isEmpty = true
                            break;
                        }
                    }
                    else if (!operator?.value) {
                        isEmpty = true
                        break;
                    }
                }
                if (column && column?.type === "date_time" && column?.value) {
                    if (operator && operator?.value && operator?.value === 'custom') {
                        if (custom_date && !(custom_date?.start_date || custom_date?.end_date)) {
                            isEmpty = true
                            break;
                        }
                        else if (!custom_date) {
                            isEmpty = true
                            break;
                        }
                    }
                    else if (!operator?.value) {
                        isEmpty = true
                        break;
                    }
                }
                else if (!column?.value) {
                    isEmpty = true
                    break;
                }

            }
            // check required fields control

            // for (const element of completeData.customFilters) {

            // }
            if (isEmpty) {
                return setAlert(alert => ({
                    ...alert,
                    show: true,
                    message: t(label + "CUSTOM-FILTER-FIELD-EMPTY"), //You must select at least 1 column
                    severity: 'error'
                }))
            }
            filter_columns = completeData.customFilters;
        }

        // widget uyumu son kez kontrol edilir.

        let v = {
            display_name: widgetTitle,
            order: order,
            row: widgetHeight,
            column: widgetWidth,
            table_columns: completeData.columns.map(x => x.value),
            dashboard_id: selectedDashboard?.id,
            widget_id: completeData.widgetVisualization?.id,
            view_report_id: selectedData.id,
            group_by_columns: completeData.groupBy?.value ? [completeData.groupBy.value] : [],
            filter_columns,
            sorting_columns: completeData.sorting ? [completeData.sorting] : [],
            persist_date_filter: completeData.persist_date_filter
        }
        let result
        if (id) {
            result = await DashBoardService.updateWidget(id, v);
        } else {
            result = await DashBoardService.createWidget(v);
        }
        if (result.status) {
            handleClose(true)
        }
    }

    return (
        <Dialog
            id="db-configure-dialog"
            data-test="autom-add-new"
            className="autom-group"
            open={true}
            onClose={handleClose}
            PaperProps={{
                style: {
                    // minWidth: "34%",
                    minWidth: step === 1 ? "35%" : "1120px",
                    maxWidth: "95%",
                    // width: "34%",
                    height: "76%",
                    width: step === 1 ? "35%" : "55%",
                    borderRadius: " 4px",
                    padding: "4px 22px 40px 22px"
                },
            }}
        >
            <DialogTitle id="db-configure-dialog-title">
                <div id="about-title" className="db-configure-header">
                    {step === 1 ? <div>
                        <h4 className="db-configure-name-title no-text-wrap">{t(label + "SELECT-FOCUS-AREA")}</h4>
                        <small
                            className="conf-field-desc">{t(label + "SELECT-FOCUS-AREA-DESCRIPTION")}</small>
                    </div>
                        : selectedReport.id
                            ? <h4 className="db-configure-name-title no-text-wrap">{t(label + selectedReport.label)}</h4>
                            : <div></div>
                    }
                    <Close className="logs-close-icon" onClick={handleClose} style={{ fontSize: "1rem" }} />
                </div>

            </DialogTitle>
            <DialogContent className={`db-widget-content-container ${step === 1 ? "db-step-1-content-container" : ""}`}>
                {step === 1 && data.length
                    ? <ReportsAccordion data={data} setSelectedData={setSelectedData} selectedData={selectedData} selectedReport={selectedReport}
                        label={label} step={step} columns={columns} setCompleteData={setCompleteData} completeData={completeData} returnToDefault={returnToDefault} />
                    :
                    selectedReport.id
                        ? <div className='db-preview-area'>
                            <ReportsAccordion data={data} setSelectedData={setSelectedData} selectedData={selectedData} selectedReport={selectedReport}
                                label={label} step={step} columns={columns} setCompleteData={setCompleteData} completeData={completeData} returnToDefault={returnToDefault} widgets={widgets} />
                            <div className='db-preview-container'>
                                <span className='db-preview-header'>{t(label + "WIDGET-PREVIEW-SAMPLE")}</span>
                                <div className='db-preview-grid-container' style={{ gridRowEnd: `span 3`, gridColumnEnd: `span 4` }}>
                                    {widgetWidth && widgetHeight ? <div
                                        className="db-preview-item"
                                        style={{
                                            gridColumn: `span ${widgetWidth || 1}`,
                                            gridRow: `span ${widgetHeight || 1}`,
                                        }}
                                    >
                                        {completeData.widgetVisualization?.img
                                            ? <img className='db-preview-image' src={completeData.widgetVisualization?.img} />
                                            : ""}
                                    </div> : ""}
                                </div>
                                <div className='db-preview-footer-container'>
                                    <div className='db-preview-footer-size-container'>
                                        <span className='db-preview-footer-text'>{t(label + "ADJUST-WIDGET-SIZE")}</span>
                                        <div className='db-width-height-container'>
                                            <div className='db-width-height-area'>
                                                <div className='db-width-height-text'>{t(label + "HEIGHT")}</div>
                                                <TextField
                                                    type="number"
                                                    value={widgetHeight}
                                                    onChange={(e) => {
                                                        let number = e.target.value
                                                        if (number > 3) {
                                                            number = 3
                                                        }
                                                        else if (number < 1) {
                                                            number = 1
                                                        }
                                                        return setWidgetHeight(Number(number))
                                                    }}
                                                    InputProps={{ inputProps: { min: 1, max: 3 } }}
                                                    margin="normal"
                                                    placeholder='max 3'
                                                    className='db-set-width-height-input'
                                                />
                                            </div>
                                            <div className='db-width-height-area'>
                                                <div className='db-width-height-text'>{t(label + "WIDTH")}</div>
                                                <TextField
                                                    type="number"
                                                    value={widgetWidth}
                                                    onChange={(e) => {
                                                        let number = e.target.value
                                                        if (number > 4) {
                                                            number = 4
                                                        }
                                                        else if (number < 1) {
                                                            number = 1
                                                        }
                                                        return setWidgetWidth(Number(number))
                                                    }}
                                                    InputProps={{ inputProps: { min: 1, max: 4 } }}
                                                    margin="normal"
                                                    placeholder='max 2'
                                                    className='db-set-width-height-input'
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className='db-preview-footer-size-container'>
                                        <div className="db-preview-footer-text">{t(label + "WIDGET-TITLE")}</div>
                                        <TextField
                                            id="filled-size-small"
                                            value={widgetTitle}
                                            onChange={(e) => {
                                                if (e.target.value?.length > 50) {
                                                    return setAlert(alert => ({
                                                        ...alert,
                                                        show: true,
                                                        message: t(label + 'MAXIMUM-CHARACTER-LIMIT-50'), //You must select at least 1 column
                                                        severity: 'error'
                                                    }))
                                                }
                                                setWidgetTitle(e.target.value)
                                            }}
                                            placeholder={completeData.widgetVisualization?.name === "string chart" && completeData.columns.length
                                                ? t(label + completeData.columns[0].label)
                                                : t(label + selectedReport?.label)}
                                            className='db-widget-title db-widget-display-name'
                                            variant="outlined"
                                            size="small"
                                            inputProps={{ style: { fontSize: 12 } }}
                                        />

                                    </div>
                                </div>
                            </div>
                        </div>
                        : <div className='db-create-loading-page'><CircularProgress /></div>
                }
            </DialogContent>
            <DialogActions className='db-dialog-action-container'>
                {step === 1
                    ? <Button className='db-next-button' onClick={handleNext} disabled={!selectedData.label} style={{ opacity: `${!selectedData.label ? "0.5" : "1"}` }}>{t(label + 'NEXT')}</Button>
                    : selectedReport?.id ?
                        <div className='db-action-buttons-container'>
                            <Button className='default-cancel-button' onClick={handleBack}>{t(label + 'BACK')}</Button>
                            {<Button className='db-next-button' onClick={handleAddToDashboard} disabled={!selectedData.label} style={{ opacity: `${!selectedData.label ? "0.5" : "1"}` }}>{t(label + `${id ? "UPDATE-WIDGET" : "ADD-TO-DASHBOARD"}`)}</Button>}
                        </div> : ""
                }
            </DialogActions>

        </Dialog >
    )
}

export default CreateWidget